<template>
  <ul class="inner-details">
    <li v-for="(modifier, key) in modifiers" :key="key">
      {{ _T_DB(modifier, 'name') }}
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: { modifiers: Array, item: Object },
  computed: {
    ...mapGetters(['_T', '_T_DB']),
  }
}
</script>
<style lang="scss" scoped>
.body-rtl {
    ul {
      padding-left: unset;
      padding-right: 0;
    }
}
.inner-details {
  text-transform: capitalize;
  width: 13.75rem;
  margin-bottom: 0.625rem;
  margin-left: -0.313rem;
  li {
    padding: 0 0 0 0.5rem;
    margin-left: 0.313rem;
    position: relative;
    border-bottom: none;
    width: auto;
    font-size: 0.75rem;
    line-height: 0.938rem;
    letter-spacing: 0.031rem;
    color: $light-font;
    font-weight: 500;
    &:first-child {
      &:after {
        display: block;
      }
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: $warning-color;
    }
  }
}
</style>
